import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { businessCategories } from "constants/apiUrls";

export interface Category {
  uuid: string;
  name: string;
  image: string;
  pinImage: string;
  pinColor: string;
  filterImage: string;
  selectedFilterTextColor: string;
  selectedFilterImage: string;
  filterBgColor: string | null;
  selectedFilterBgColor: string | null;
}

const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      headers.set("bludot-app-name", "business-rewards");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    categories: builder.query<Category[], void>({
      query: () => businessCategories,
    }),
  }),
});

export const { useCategoriesQuery } = categoryApi;
export default categoryApi;
